
export default {
  name: 'GotoTop',
  data() {
    return {
      fab: false,
      acceptConsent: false,
      consent: null,
      pdfUrl: 'https://etax.one.th/tempimg/Cookie-Policy-INET-e-Tax.pdf',
    }
  },
  mounted() {
    setTimeout(() => {
      this.fn_checkCookie()
    }, 1000)
  },
  methods: {
    fn_checkCookie() {
      this.consent = this.$cookies.get('cookie-consent')

      if (this.consent === 'accept') {
        this.acceptConsent = false
      } else {
        this.acceptConsent = true
      }
    },
    fn_rejectConsenet() {
      this.$cookies.set('cookie-consent', 'reject', '90d')
      this.acceptConsent = false
    },
    fn_acceptConsent() {
      this.$cookies.set('cookie-consent', 'accept', '90d')
      this.acceptConsent = false
    },
    fn_previewPdf() {
      window.open(this.pdfUrl, '_blank')
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
  },
}
